import React, { FC } from 'react';
import VideoJsPlayer from 'video.js';
import { create } from 'zustand';

export interface GlobalMediaStore {
  /** Currently active media player */
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  player?: VideoJsPlayer;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  setPlayer: (player?: VideoJsPlayer) => void;
  cleanupPlayer: () => void;
}

const _useGlobalMediaStore = create<GlobalMediaStore>(set => ({
  setPlayer: player => set({ player }),
  cleanupPlayer: () =>
    set(state => {
      if (state.player) {
        try {
          // Pause the currently playing media
          state.player.pause();
          // Optionally reset to start
          state.player.currentTime(0);
          // Dispose player if needed
          state.player.dispose();
        } catch (e) {
          console.warn('Failed to clean up player:', e);
        }
      }
      return { player: undefined };
    })
}));

/**
 * Provider that keeps track of the currently active media player globally
 * This allows players to know whether they can play their media or not
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const GlobalMediaProvider: FC = ({ children }: { children: any }) => (
  <>{children}</>
);

export const useGlobalMediaStore = _useGlobalMediaStore;
